export default "/assets/weigh-ins-loss-placeholder.png";